import * as React from 'react';
import { permissionGroupHelper, PermissionGroupId, UserToken } from '../../../../../amorg-common';
import { applicationEndpoints } from '../../../../../amorg-common/applicationEndpoints';
import { clientAccessHelper } from '../../../../../utils/clientAccessHelper';
import { LeftMenuNavigation } from './LeftMenuNavigation';

type MainNavigationProps = {
    activeUser: UserToken | null,
    selectedMenuItemKey?: string;
    isMobileNavigationOpen: boolean;
    onCloseMobileNavigation: () => void;
};

export const MainNavigation = ({ activeUser, selectedMenuItemKey, isMobileNavigationOpen, onCloseMobileNavigation }: MainNavigationProps): JSX.Element => 
{
    
    // function hasPermission(permission:Permission): boolean
    // {
    //     if(activeUser?.individualPermissions.some(p => p === permission))
    //         return true;

    //     const pg = PermissionGroups.all.find(pg => pg.id === activeUser?.permissionGroupId);
    //     if(!pg)
    //         return false;
    //     return pg.permissions.includes(permission);
    // }

    function hasPermissionGroupId(requiredPermissionGroupId:PermissionGroupId): boolean
    {
        if(!activeUser) return false;
        return permissionGroupHelper.hasMinimumPermissionGroup(activeUser.permissionGroupId, requiredPermissionGroupId);
    }

    
    const userFeatures = activeUser?.features || [];

    return (
        <LeftMenuNavigation
            activeUser={activeUser}
            selectedMenuItemKey={selectedMenuItemKey}
            isMobileNavigationOpen={isMobileNavigationOpen}
            onCloseMobileNavigation={onCloseMobileNavigation}
            items={[
                {
                    type:'menu-item',
                    menuItemKey:'dashboard',
                    icon:'dashboard',
                    text:'Overblik',
                    href:'/',
                    show:!userFeatures.includes('ArticleLandingPage'),
                },
                {
                    type:'menu-item',
                    menuItemKey:'workplaceassessment',
                    icon:'assignment',
                    text:'APV',
                    href:'/workplaceassessments',
                    show:hasPermissionGroupId('member') && userFeatures.includes('WorkplaceAssessment'),
                },
                {
                    type:'menu-item',
                    menuItemKey:'workgroupmeeting',
                    icon:'calendar_month',
                    text:'AMO møde',
                    href:'/workgroupmeetings',
                    show:hasPermissionGroupId('member') && userFeatures.includes('Meeting')
                },
                {
                    type:'menu-item',
                    menuItemKey:'annualworkgroupstatus',
                    icon:'forum',
                    text:'Årlig drøftelse',
                    href:'/annualworkgroupstatus',
                    show:hasPermissionGroupId('member') && userFeatures.includes('AnnualStatus')
                },
                {
                    type:'menu-item',
                    menuItemKey:'actionplans',
                    icon:'list_alt_check',
                    text:'Handleplaner',
                    href:'/actionplans',
                    show:userFeatures.includes('ActionPlans'),
                },
                {
                    type:'menu-item',
                    menuItemKey:'incidents',
                    icon:'record_voice_over',
                    text:'Indberetninger',
                    href:'/incidents',
                    show:clientAccessHelper.canAccessIncidents(activeUser)
                },
                {
                    type:'menu-item',
                    menuItemKey:'articles',
                    icon:'balance',
                    text:'Lovservice',
                    href:'/articles',
                    show:hasPermissionGroupId('member') && userFeatures.includes('Articles')
                },
                {
                    type:'menu-item',
                    menuItemKey:'articleslight',
                    icon:'gavel',
                    text:'Videndatabasen',
                    href:'/articles/summary',
                    show:hasPermissionGroupId('member') && userFeatures.includes('ArticlesLight')
                },
                {
                    type:'menu-item',
                    menuItemKey:'ergonomics',
                    icon:'physical_therapy',
                    text:'Ergonomi',
                    href:'/ergonomics',
                    show:hasPermissionGroupId('member') && userFeatures.includes('CustomForms')
                },
                {
                    type:'menu-item',
                    menuItemKey:'safetyinspection',
                    icon:'verified_user',
                    text:'Sikkerhedsrundering',
                    href:'/safetyinspections',
                    show:userFeatures.includes('SafetyInspection')
                },
                {
                    type:'menu-divider',
                },
                {
                    type:'menu-item-group',
                    menuItemGroupKey:'resources',
                    text:'Ressourcer',
                    subItems:[
                        {
                            type:'menu-item',
                            menuItemKey:'externallinks',
                            icon:'interface_actions_link',
                            text:'Eksterne links',
                            href:'/externallinks',
                            show:hasPermissionGroupId('member') && userFeatures.includes('ExternalLinks')
                        },
                        {
                            type:'menu-item',
                            menuItemKey:'documentarchive',
                            icon:'data_files_document',
                            text:'Dokumentarkiv',
                            href:'/documentarchive',
                            show:hasPermissionGroupId('member') && userFeatures.includes('DocumentArchive')
                        },
                        {
                            type:'menu-item',
                            menuItemKey:'learning',
                            icon:'school',
                            text:'Opslagsværket',
                            href:'/learning',
                            show:hasPermissionGroupId('member') && userFeatures.includes('Learning')
                        },
                        {
                            type:'menu-item',
                            menuItemKey:'portal',
                            icon:'captive_portal',
                            text:'Medarbejderportalen',
                            href:applicationEndpoints.portal,
                            show:hasPermissionGroupId('member') && userFeatures.includes('EmployeePortal')
                        }
                    ]
                },
                {
                    type:'menu-item-group',
                    menuItemGroupKey:'administration',
                    text:'Administration',
                    subItems:[
                        {
                            type:'menu-item',
                            menuItemKey:'workgroups',
                            icon:'interface_user_team',
                            text:'Organisationen',
                            href:'/organization',
                            show:hasPermissionGroupId('member') && userFeatures.includes('Organization'),
                        },
                        {
                            type:'menu-item',
                            menuItemKey:'locations',
                            icon:'navigation_home',
                            text:'Lokationer',
                            href:'/locations',
                            show:hasPermissionGroupId('member') && (userFeatures.includes('Locations') || userFeatures.includes('SafetyInspection')),
                        },
                        {
                            type:'menu-item',
                            menuItemKey:'users',
                            icon:'interface_user_users',
                            text:'Brugere',
                            href:'/users',
                            show:hasPermissionGroupId('member')
                        },
                        {
                            type:'menu-item',
                            menuItemKey:'settings',
                            icon:'navigation_settings',
                            text:'Indstillinger',
                            href:'/settings',
                            show:hasPermissionGroupId('siteadmin') && userFeatures.includes('EmployeePortal')
                        }
                    ]
                }

            ]}
        />
    );
};